import BottomNavBar from "../../components/BottomNavBar";
import SideBar from "../../components/sidebar/SideBar";
import appContext from "../../context/appContext";
import { useContext } from "react";
//style
import "../../styles/layout/sideBarLayout.scss";
import {
  AvTimerRounded,
  BarChart,
  ChevronLeft,
  ExitToAppRounded,
  Notifications,
} from "@mui/icons-material";
import { Outlet } from "react-router-dom";
const SideBarLayout = () => {
  const { collapse, setCollapse, userLogout } = useContext(appContext);

  return (
    <div className={`sideBarLayout `}>
      <div className="elements d-flex justify-content-end">
        <div className="w-100 Outlet">
          <Outlet />
        </div>

        <div
          className={`d-lg-block  d-none closeBtn ${collapse ? "open" : ""} `}
          onClick={() => setCollapse(!collapse)}
        >
          <ChevronLeft />
        </div>
        <SideBar />
        {/* SideBar */}
      </div>

      <div className="d-lg-none  d-block pb-5">
        {/* BottomNavBar */}
        <BottomNavBar />
      </div>
    </div>
  );
};

export default SideBarLayout;
